module.exports = __webpack_public_path__ + "img/tip_2.4202f059.png";